// The six kid colours. Each kid owns one and it is that kid's accent everywhere their data
// appears; the rest of the app stays neutral. Every colour carries white text at 4.5:1 or
// better and still stands out at 3:1 or better against the dark-mode background
// (palette.test.ts checks both), so one value works in light and dark mode.

export const KID_COLOURS = [
  "#D03A3A", // red
  "#B45309", // orange
  "#15803D", // green
  "#1D6FD6", // blue
  "#8450D8", // purple
  "#C0267F", // pink
] as const;

export type KidColour = (typeof KID_COLOURS)[number];

/** The colour a new kid gets by default: the next one along, wrapping round after six. */
export function defaultColour(index: number): KidColour {
  const n = KID_COLOURS.length;
  return KID_COLOURS[((index % n) + n) % n];
}

export function isKidColour(value: string): value is KidColour {
  return (KID_COLOURS as readonly string[]).includes(value.toUpperCase());
}
